import styled from "styled-components";

interface SoftSubTextProps {
  $tone?: "light" | "dark";
}

const SoftSubText = styled.p<SoftSubTextProps>`
  font-family: "Space Grotesk", sans-serif;
  font-size: 1.65rem;
  font-weight: 400;
  line-height: 1.75;
  color: ${(props) =>
    props.$tone === "light"
      ? "rgba(255, 222, 231, 0.72)"
      : "rgba(126, 102, 110, 0.82)"};

  @media only screen and (max-width: 600px) {
    font-size: 1.45rem;
    line-height: 1.7;
  }

  @media only screen and (min-width: 601px) and (max-width: 1200px) {
    font-size: 1.55rem;
  }
`;

export default SoftSubText;
